import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=af144992&scoped=true&"
import script from "./OfferCard.vue?vue&type=script&lang=js&"
export * from "./OfferCard.vue?vue&type=script&lang=js&"
import style0 from "./OfferCard.vue?vue&type=style&index=0&id=af144992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af144992",
  null
  
)

export default component.exports